/**
 * @generated SignedSource<<b45311e5591a1695d74ff4f15c326d38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type searchProfileMatchNotification_fragment$data = {
  readonly createdDate: any;
  readonly read: boolean;
  readonly searchProfile: {
    readonly id: string;
    readonly name: string | null | undefined;
  };
  readonly " $fragmentType": "searchProfileMatchNotification_fragment";
};
export type searchProfileMatchNotification_fragment$key = {
  readonly " $data"?: searchProfileMatchNotification_fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchProfileMatchNotification_fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "searchProfileMatchNotification_fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "read",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "searchProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdDate",
      "storageKey": null
    }
  ],
  "type": "SearchProfileMatchNotification",
  "abstractKey": null
};

(node as any).hash = "f9531fb05d9ad94010843e7d21e74643";

export default node;
